import useReservationFluxStore, { clearFluxData } from "@app-store/reservation-flux";
import useSystemStore from "@app-store/system";
import { trackUserEvent } from "@app-utilities/observability";
import { AppInsightsEvent } from "@app-utilities/observability-events";
import { NavigationGuardNext, RouteLocationNormalizedLoaded, RouteRecordNameGeneric } from "vue-router";

import router from ".";
import { attractionsBook, attractionsPages, attractionsThankyouPage } from "./routes/attractions";
import { maintenanceMode } from "./routes/base";
import { home } from "./routes/reservations";

type ReservationHomeOptions = {
    modeOverride?: "attractions" | "bowling";
    currentQuery?: RouteLocationNormalizedLoaded["query"];
	currentName?: RouteRecordNameGeneric;
};

export function getReservationHome(options: ReservationHomeOptions) {
	const { modeOverride, currentName } = options;

	let currentQuery = options.currentQuery ?? {};

	if(currentName === attractionsThankyouPage)
		currentQuery = {};
	else {
		const { reservationId } = currentQuery;
        currentQuery = reservationId ? { reservationId } : {};
		// filter the user's choices during the last attraction selection to keep only the reservation ID
	}

	const SystemStore = useSystemStore();
	const fluxStore = useReservationFluxStore();
	const mode = modeOverride ?? fluxStore.mode;
	const homeViewName = mode === "attractions" ? attractionsBook : home;

	return router.resolve({
		name: homeViewName,
		params: {
			companyId: Number(SystemStore.info?.CompanyId) + "",
			systemId: Number(SystemStore.info?.Id) + ""
		},
		query: currentQuery
	});
}
export function redirectToMaintenanceMode(next?: Function) {
	const SystemStore = useSystemStore();
	const currentRoute = router.currentRoute.value;
	trackUserEvent(AppInsightsEvent.RedirectToMaintenanceMode, { currentRoute });
	const route = {
		name: maintenanceMode,
		params: {
			companyId: Number(SystemStore.info?.CompanyId) + "",
			systemId: Number(SystemStore.info?.Id) + ""
		}
	};
	clearFluxData();
	if (next) return next(route);
	else return router.push(route);
}
export function getReservationHomeHref(currentRoute: RouteLocationNormalizedLoaded) {
	if (currentRoute.name === "root") return "#";
	return getReservationHome({ currentQuery: currentRoute.query, currentName: currentRoute.name }).href;
}
export function isSkippable(targetRoute: RouteLocationNormalizedLoaded, next?: NavigationGuardNext) {
	const isSkippable = [undefined, null, ""].indexOf(targetRoute.name?.toString()) > -1;

	if (isSkippable && next) next();
	return isSkippable;
}
export function isB2CService(route: RouteLocationNormalizedLoaded) {
	return route.params && "systemId" in route.params;
}
export function isFullscreenPage(route: RouteLocationNormalizedLoaded) {
	return (route.name === "browser-not-supported" || route.name === "disabled-features");
}
export function setFluxMode(route: RouteLocationNormalizedLoaded) {
	const fluxStore = useReservationFluxStore();
	const routeName = route.name?.toString();
	if (!routeName) throw new Error("Route name is not defined");

	if (attractionsPages.includes(routeName)) fluxStore.setFluxMode("attractions");
	else fluxStore.setFluxMode("bowling");
}
